import React from 'react';
import { Smartphone, Shield, Zap, Heart } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: <Smartphone size={24} />,
      title: "Android Product Focus",
      description: "Dedicated to crafting refined, native Android software products"
    },
    {
      icon: <Shield size={24} />,
      title: "Privacy as a Standard",
      description: "Offline-first architectures that protect user data by design"
    },
    {
      icon: <Zap size={24} />,
      title: "Lightweight & Fast",
      description: "Optimized Kotlin codebases free of bloat and background drain"
    },
    {
      icon: <Heart size={24} />,
      title: "User-Centric Utility",
      description: "Every product is built to solve a genuine, practical everyday need"
    }
  ];

  return (
    <section id="about" className="section about">
      <div className="container">
        <div className="section-header animate-on-scroll">
          <span className="section-badge">About JustLabs</span>
          <h2 className="section-title">An Independent Software Product Company</h2>
          <p className="section-subtitle">
            We build, publish, and maintain focused Android applications and specialized enterprise software that users and businesses rely on every single day.
          </p>
        </div>
        
        <div className="about-content">
          <div className="about-text animate-on-scroll">
            <h3>Building Focused Software Products That Respect Users</h3>
            <p>
              At JustLabs, our mission is to create software products that do one thing exceptionally well — without unnecessary bloat, intrusive tracking, or complicated onboarding.
            </p>
            
            <div className="founder-spotlight-card">
              <div className="founder-badge-header">
                <span className="founder-tag">Founder & Principal Developer</span>
              </div>
              <h4 className="founder-name">Pankaj Acharya</h4>
              <p className="founder-desc">
                JustLabs is founded and operated by <strong>Pankaj Acharya</strong> (Sole Proprietor). As an independent software company, we take pride in personally engineering our software products — from high-utility consumer tools like <strong>JustPDF</strong>, <strong>JustPrint</strong>, <strong>JustSaver</strong>, and <strong>JustConverter</strong> to specialized enterprise software like <strong>JustSolar</strong>.
              </p>
            </div>

            <p>
              We believe in sustainable software: lean native architectures, offline reliability, respect for user attention, and continuous refinement through direct community feedback.
            </p>
            
            <div className="about-features">
              {features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-icon">
                    {feature.icon}
                  </div>
                  <div className="feature-content">
                    <h4>{feature.title}</h4>
                    <p>{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="about-visual animate-on-scroll">
            <div className="about-image product-studio-badge">
              <Smartphone size={100} className="studio-phone-icon" />
              <div className="studio-pill-tag">Software Product Studio</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;